function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 14L3 14C1.34314 14 -1.78993e-06 12.6569 -1.64508e-06 11L-9.45698e-07 3C-8.00851e-07 1.34315 1.34315 1.01469e-07 3 2.46316e-07L19 1.64508e-06C20.6569 1.78993e-06 22 1.34315 22 3L22 11C22 12.6569 20.6569 14 19 14ZM3 12L19 12C19.5523 12 20 11.5523 20 11L20 3C20 2.44772 19.5523 2 19 2L3 2C2.44771 2 2 2.44772 2 3L2 11C2 11.5523 2.44771 12 3 12Z",
  fill: "#189BC5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 8C10.794 8 11.206 8 13.5 8C13.7652 8 14.0196 7.89464 14.2071 7.70711C14.3946 7.51957 14.5 7.26522 14.5 7C14.5 6.73478 14.3946 6.48043 14.2071 6.29289C14.0196 6.10536 13.7652 6 13.5 6C11.206 6 10.794 6 8.5 6C8.23478 6 7.98043 6.10536 7.79289 6.29289C7.60536 6.48043 7.5 6.73478 7.5 7C7.5 7.26522 7.60536 7.51957 7.79289 7.70711C7.98043 7.89464 8.23478 8 8.5 8Z",
  fill: "#189BC5"
});

var SvgDeleteRow = function SvgDeleteRow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteRow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_row.de6fab4a.svg";
export { ForwardRef as ReactComponent };